<div class="table-page fraud-overview" dir="rtl">
  <div class="fraud-overview-toolbar">
    <h2>نمای کلی</h2>
    <div class="actions" [formGroup]="dateForm">
      <label for="fraud-analysis-date">تاریخ تحلیل</label>
      <ng-persian-datepicker class="fraud-datepicker" [uiTheme]="'gray'" [timeEnable]="false"
        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'" [dateGregorianFormat]="'YYYY/MM/DD'"
        [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true">
        <input id="fraud-analysis-date" class="control" type="text" dir="ltr" readonly formControlName="date" />
      </ng-persian-datepicker>
      <button class="btn btn-primary" type="button" [disabled]="isLoading" (click)="loadOverview()">
        <i class="fa fa-refresh" aria-hidden="true"></i>
        بروزرسانی
      </button>
    </div>
  </div>

  <section *ngIf="summaryLoading || summaryError || !summary" class="card fraud-summary-state">
    <div *ngIf="summaryLoading" class="loader show">
      <div class="spinner"></div>
      <span>در حال دریافت خلاصهٔ آمار...</span>
    </div>
    <div *ngIf="!summaryLoading && summaryError" class="state show error">
      <i class="fa fa-exclamation-triangle ico-big" aria-hidden="true"></i>
      <p>{{ summaryError }}</p>
      <button class="btn btn-ghost" type="button" (click)="loadOverview()">تلاش دوباره</button>
    </div>
    <div *ngIf="!summaryLoading && !summaryError && !summary" class="state show">
      <p>خلاصهٔ آماری برای این روز ثبت نشده است.</p>
    </div>
  </section>

  <section *ngIf="summary" class="fraud-summary-cards">
    <article *ngFor="let card of summaryCards" class="fraud-stat" [ngClass]="'fraud-stat-' + card.accent">
      <div class="fraud-stat-label">{{ card.label }}</div>
      <div class="fraud-stat-value">{{ (card.value | number:card.numberFormat) ?? '—' | faNum }}</div>
      <div class="fraud-stat-note">{{ card.note }}</div>
    </article>
  </section>

  <div class="fraud-overview-split">
    <section class="card fraud-cases-panel">
      <div class="fraud-panel-heading">
        <h2>پرونده‌های روز انتخاب‌شده</h2>
        <a class="btn btn-ghost" routerLink="../cases">
          مشاهده همه
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
      </div>
      <div class="body">
        <div *ngIf="casesLoading" class="loader show">
          <div class="spinner"></div>
          <span>در حال دریافت پرونده‌ها...</span>
        </div>
        <div *ngIf="!casesLoading && casesError" class="state show error">
          <i class="fa fa-exclamation-triangle ico-big" aria-hidden="true"></i>
          <p>{{ casesError }}</p>
          <button class="btn btn-ghost" type="button" (click)="loadOverview()" [disabled]="isLoading">تلاش دوباره</button>
        </div>
        <div *ngIf="!casesLoading && !casesError && !cases.length" class="state show">
          <i class="fa fa-folder-open-o ico-big" aria-hidden="true"></i>
          <h3>برای این روز پرونده‌ای یافت نشد.</h3>
          <p>تاریخ تحلیل را تغییر دهید تا پرونده‌های روز دیگری نمایش داده شوند.</p>
        </div>
        <div *ngIf="!casesLoading && !casesError && cases.length" class="table-scroll">
          <table>
            <thead>
              <tr>
                <th>پرونده</th>
                <th>خودروی اول</th>
                <th>خودروی دوم</th>
                <th>بازه حرکت</th>
                <th>امتیاز</th>
                <th>حرکت مشترک</th>
                <th>وضعیت</th>
                <th>جزئیات</th>
              </tr>
            </thead>
            <tbody class="still">
              <tr *ngFor="let item of cases">
                <td><bdi>#{{ item.iFraudMovementGroup | faNum }}</bdi></td>
                <td>
                  <div class="fraud-vehicle-info">
                    <strong>{{ item.strFullName1 || '—' }}</strong>
                    <span class="muted">موبایل: <bdi dir="ltr">{{ item.strMobile1 || '—' | faNum }}</bdi></span>
                    <span class="muted">پلاک: <bdi>{{ item.strVehicleNo1 || '—' | faNum }}</bdi></span>
                  </div>
                </td>
                <td>
                  <div class="fraud-vehicle-info">
                    <strong>{{ item.strFullName2 || '—' }}</strong>
                    <span class="muted">موبایل: <bdi dir="ltr">{{ item.strMobile2 || '—' | faNum }}</bdi></span>
                    <span class="muted">پلاک: <bdi>{{ item.strVehicleNo2 || '—' | faNum }}</bdi></span>
                  </div>
                </td>
                <td><bdi dir="ltr">{{ item.timeRange | faNum }}</bdi></td>
                <td>{{ (item.fFraudScore | number:'1.2-2') ?? '—' | faNum }}</td>
                <td>{{ item.iCommonMovementMinutes | number | faNum }} دقیقه</td>
                <td><span class="tag" [ngClass]="item.reviewClass">{{ item.reviewLabel }}</span></td>
                <td>
                  <a class="fraud-details-link" target="_blank" rel="noopener" routerLink="../case"
                    [queryParams]="{ id: item.iFraudMovementGroup }">جزئیات</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section class="card fraud-review-panel">
      <div class="fraud-panel-heading"><h2>وضعیت بررسی پرونده‌ها</h2></div>
      <div class="fraud-panel-content">
        <p *ngIf="summaryLoading" class="muted">در حال دریافت وضعیت بررسی...</p>
        <p *ngIf="!summaryLoading && summaryError" class="fraud-inline-error">{{ summaryError }}</p>
        <p *ngIf="!summaryLoading && !summaryError && !summary" class="muted">اطلاعات بررسی برای این روز ثبت نشده است.</p>
        <ng-container *ngIf="summary">
          <div class="fraud-review-stats">
            <div><span>در انتظار</span><strong>{{ summary.iPendingCases | number | faNum }}</strong></div>
            <div><span>تأیید</span><strong>{{ summary.iConfirmedCases | number | faNum }}</strong></div>
            <div><span>رد</span><strong>{{ summary.iRejectedCases | number | faNum }}</strong></div>
          </div>
          <dl class="fraud-review-details">
            <div><dt>میانگین امتیاز پرونده‌ها</dt><dd>{{ (summary.fAverageFraudScore | number:'1.2-2') ?? '—' | faNum }}</dd></div>
            <div><dt>مجموع حرکت مشترک مشکوک</dt><dd>{{ summary.iTotalCommonMovementMinutes | number | faNum }} دقیقه</dd></div>
          </dl>
        </ng-container>

        <div class="fraud-analysis-heading">
          <h2>وضعیت پردازش روز</h2>
          <a routerLink="../analysis">مشاهده وضعیت</a>
        </div>
        <p *ngIf="analysisLoading" class="muted">در حال دریافت وضعیت پردازش...</p>
        <div *ngIf="!analysisLoading && analysisError" class="fraud-inline-error">
          <p>{{ analysisError }}</p>
          <button class="btn btn-ghost" type="button" (click)="loadOverview()" [disabled]="isLoading">تلاش دوباره</button>
        </div>
        <p *ngIf="!analysisLoading && !analysisError && !analysis" class="muted">اطلاعات وضعیت پردازش برای این روز ثبت نشده است.</p>
        <ng-container *ngIf="analysis">
          <div class="fraud-analysis-caption">
            <strong>{{ analysisProgress | faNum }}٪ تکمیل</strong>
            <span class="muted">{{ analysis.iCompletedWindows | number | faNum }} از {{ analysis.iTotalWindows | number | faNum }} بازه</span>
          </div>
          <progress class="fraud-progress" [value]="analysisProgress" max="100"></progress>
          <div class="fraud-analysis-counts muted">
            <span>در حال اجرا: {{ analysis.iRunningWindows | number | faNum }}</span>
            <span>در انتظار: {{ analysis.iPendingWindows | number | faNum }}</span>
            <span>خطادار: {{ analysis.iFailedWindows | number | faNum }}</span>
          </div>
        </ng-container>
      </div>
    </section>
  </div>
</div>
